// extracted by mini-css-extract-plugin
export default {"historyContainer":"history_historyContainer__ti8kD","main":"history_main__svS4u","videos":"history_videos__p-+vh","clearHistory":"history_clearHistory__jF1dz"};